import React, { useState } from "react";
import { View, Text, Image, ScrollView } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import { TextInput } from "react-native-paper";

import HeaderDefault from "../../components/HeaderDefault";
import Button from "../../components/Button";

import styles from "./styles";

const Sell = () => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState([
        {
            label: "GPX",
            value: "gpx",
            icon: () => (
                <Image
                    source={require("../../../assets/imgs/gpx.png")}
                    style={styles.iconSelect}
                />
            ),
        },
    ]);
    return (
        <>
            <HeaderDefault title={"Vender"} />

            <ScrollView style={styles.content}>
                <Text style={styles.title}>Desejo vender:</Text>

                <View style={styles.contentSelect}>
                    <DropDownPicker
                        open={open}
                        value={value}
                        items={items}
                        containerStyle={styles.dropdown}
                        placeholder="Selecione"
                        setOpen={setOpen}
                        setValue={setValue}
                        setItems={setItems}
                    />
                </View>
                <Text style={styles.textAmount}>
                    Quantidade disponível:{" "}
                    <Text style={{ fontWeight: "400" }}>32,280,00BRL</Text>
                </Text>

                <TextInput
                    left={<TextInput.Icon name="currency-brl" />}
                    style={{ backgroundColor: "#F2F2F2", marginTop: 50 }}
                    keyboardType="numeric"
                />
                <Text style={styles.price}>1GPX = XBRL (cotação)</Text>
            </ScrollView>

            <Button route={"PaymentMethodSell"} text={"CONTINUAR"} />
        </>
    );
};

export default Sell;
